import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { Map, List } from 'immutable';
import { TagActions } from '../actions/tag';
import { ViewActions } from '../actions/view';
import { ProjectActions } from '../actions/project';
import { ElementActions } from '../actions/element';
import { RelationshipActions } from '../actions/relationship';
import { currentElementSelector } from './elements';

const projectActions = getActionIds(ProjectActions);
const viewActions = getActionIds(ViewActions);
const tagActions = getActionIds(TagActions);
const elementActions = getActionIds(ElementActions);
const relationshipActions = getActionIds(RelationshipActions);

const initialState = Immutable.fromJS({
  tags: {},
  loading: false,
  loaded: false,
});

export const tags = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [elementActions.getElement.success]: (state, action) => {
    if (!action.result.entities.tags) return state;
    const results = action.result.entities.tags;
    let tagData = {};

    Object.keys(results).forEach(function(key) {
      tagData[key] = { tag: results[key].tag, id: results[key].id };
    });

    return state.mergeDeep({
      tags: tagData,
    });
  },

  [projectActions.getRootElement.success]: (state, action) => {
    if (!action.result.entities.tags) return state;
    const results = action.result.entities.tags;
    let tagData = {};

    Object.keys(results).forEach(function(key) {
      tagData[key] = { tag: results[key].tag, id: results[key].id };
    });

    return state.mergeDeep({
      tags: tagData,
    });
  },

  [relationshipActions.getRelationship.success]: (state, action) => {
    if (!action.result.entities.tags) return state;
    const results = action.result.entities.tags;
    let tagData = {};

    Object.keys(results).forEach(function(key) {
      tagData[key] = { tag: results[key].tag, id: results[key].id };
    });

    return state.mergeDeep({
      tags: tagData,
    });
  },

  // [tagActions.creatProjectTag.success]: (state, action) => {
  //   if (!action.result.entities.tags) return state;
  //   const results = action.result.entities.tags;
  //   let tagData = {};
  //
  //   Object.keys(results).forEach(function(key) {
  //     tagData[key] = { tag: results[key].tag, id: results[key].tag_id };
  //   });
  //
  //   return state.mergeDeep({
  //     tags: tagData,
  //   });
  // },

  [tagActions.tagObject.begin]: (state, action) => {
    return state.mergeDeep({
      loading: true,
    });
  },

  [tagActions.tagObject.failure]: (state, action) => {
    return state.mergeDeep({
      loading: false,
    });
  },

  [tagActions.tagObject.success]: (state, action) => {
    if (!action.result || !action.result.entities.tags) return state;
    const results = action.result.entities.tags;
    let tagData = {};

    Object.keys(results).forEach(function(key) {
      tagData[key] = { tag: results[key].tag, id: results[key].id };
    });

    return state.mergeDeep({
      tags: tagData,
      loading: false,
    });
  },

  [viewActions.tagDefaultCycles.success]: (state, action) => {
    if (
      !action.result ||
      !action.result.elements ||
      !action.result.elements.entities.tags
    )
      return state;
    const results = action.result.elements.entities.tags;
    let tagData = {};

    Object.keys(results).forEach(function(key) {
      tagData[key] = { tag: results[key].tag, id: results[key].id };
    });

    return state.mergeDeep({
      tags: tagData,
    });
  },

  // [tagActions.getElementTags.success]: (state, action) => {
  //   if (!action.result.data.entities.tags) return state;
  //   return state.mergeDeep({
  //     tags: action.result.data.entities.tags,
  //     loading: false,
  //     loaded: true,
  //   });
  // },
  //
  // [tagActions.getElementTags.begin]: (state, action) => {
  //   if (!action.result.data.entities.tags) return state;
  //   return state.mergeDeep({
  //     loading: true,
  //   });
  // },

  // [tagActions.getTagsByIds.begin]: (state, action) => {
  //   return state.mergeDeep({
  //     loading: true,
  //   });
  // },
  //
  // [tagActions.getTagsByIds.success]: (state, action) => {
  //   if (!action.result.entities.tags) return state;
  //   return state.mergeDeep({
  //     tags: action.result.entities.tags,
  //   });
  // },
  //
  // [tagActions.getTagsByIds.failure]: (state, action) => {
  //   return state.mergeDeep({
  //     loading: false,
  //   });
  // },

  // [tagActions.getProjectTags.begin]: (state, action) => {
  //   return state.mergeDeep({
  //     loading: true,
  //   });
  // },
  //
  // [tagActions.getProjectTags.success]: (state, action) => {
  //   if (!action.result.entities.tags) return state;
  //   return state.mergeDeep({
  //     tags: action.result.entities.tags,
  //     loading: false,
  //     loaded: true,
  //   });
  // },
  //
  // [tagActions.getProjectTags.failure]: (state, action) => {
  //   return state.mergeDeep({
  //     loading: false,
  //   });
  // },

  // [tagActions.getTaggedObjectsCount.begin]: (state, action) => {
  //   return state.mergeDeep({
  //     loading: true,
  //   });
  // },
  //
  // [tagActions.getTaggedObjectsCount.success]: (state, action) => {
  //   return state.mergeDeep({
  //     loading: false,
  //   });
  // },
  //
  // [tagActions.getTaggedObjectsCount.failure]: (state, action) => {
  //   return state.mergeDeep({
  //     loading: false,
  //   });
  // },

  // [tagActions.deleteTagFromProject.success]: (state, action) => {
  //   return state.deleteIn(['tags', action.result.tagId]);
  // },
});

export const tagsSelector = (state, props) => {
  return state.tags.get('tags');
};

export const elementTagsSelector = (state, props) => {
  const currentElement = currentElementSelector(state, props);
  const allTags = state.tags.get('tags');

  if (!currentElement || !allTags || allTags.size === 0) return null;

  const elementTags = currentElement.get('tags');
  // eslint-disable-next-line new-cap
  let tagsList = List();

  if (!elementTags || elementTags.size === 0) return null;

  elementTags.forEach(t => {
    tagsList = tagsList.push(
      // eslint-disable-next-line new-cap
      Map({ id: allTags.getIn([t, 'id']), tag: allTags.getIn([t, 'tag']) }),
    );
  });

  return tagsList;
};

export const tagsLoadingSelector = (state, props) => {
  return state.tags.get('loading');
};



// WEBPACK FOOTER //
// ./src/reducers/tags.js